const style = () => ({
  tooltip: {
    width: 'max-content',
    whiteSpace: 'nowrap'
  }
});

export default style;
